import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";

export default function PremiumBusinessCard({
  data,
  onArticleClick,
  imgH = "",
}) {
  const {
    name,
    short_description,
    description,
    cover_image,
    logo,
    itemcategory_name,
    facebook_url,
    youtube_url,
    instagram_url,
    linkedin_url,
    twitter_url,
    business_location,
    business_time,
    city,
    state,
    post_url,
  } = data || {};

  const imgSrc = cover_image || "/placeholder.png";

  return (
    <article
      className="
         bg-white rounded-xl border border-gray-200 
        shadow-md overflow-hidden
        hover:shadow-2xl hover:-translate-y-1
        transition-all duration-300 group

        flex flex-col h-full
      "
    >
      {/* Cover Image */}
      <div className="relative h-52 w-full overflow-hidden rounded-t-xl">
        <img
          src={imgSrc}
          alt={name || "Business"}
          className="w-full h-full object-fill transition-transform duration-300 group-hover:scale-105"
        />

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

        {/* Category badge */}
        <span className="absolute top-0 left-0 bg-orange-600 text-white text-xs font-semibold px-3 py-1 rounded-e-full shadow-md">
          {itemcategory_name || "Business"}
        </span>

        {/* Logo badge */}
        {logo && (
          <img
            src={logo}
            alt="logo"
            className="absolute -bottom-8 left-4 w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover bg-white"
          />
        )}
      </div>

      {/* Content */}
      <div className="pt-2 px-4 pb-4 text-center flex flex-col flex-1 h-[600px]">
        <h2 className="text-[16px] font-bold text-[#9d2e43]  line-clamp-1">
          {name || "Business"}
        </h2>

        {(business_location || city || state) && (
          <p className="text-sm text-gray-500 mt-1">
            {business_location && <span>{business_location}</span>}
            {(city || state) && (
              <span>
                {business_location ? " | " : ""}
                {city}
                {city && state ? ", " : ""}
                {state}
              </span>
            )}
          </p>
        )}

        <p className="text-sm text-gray-500 mt-1">Hours: {business_time}</p>
        {/* {business_time && (
        )} */}

        {/* ✅ This grows and pushes bottom area down */}
        <p className="text-[14px] !text-[#6a6868] mt-3 line-clamp-3 flex-grow  h-[90px]">
          {short_description ||
            description ||
            "A trusted business providing excellent services."}
        </p>

        {/* ✅ Bottom-fixed area */}
        {/* ✅ Bottom-fixed area */}
        <div className="mt-auto pt-4">
          {/* Social Icons (moved ABOVE buttons) */}
          <div className="h-[32px]">
            {(facebook_url ||
              youtube_url ||
              twitter_url ||
              instagram_url ||
              linkedin_url) && (
              <>
                <div className="flex justify-center gap-2 ">
                  {facebook_url && (
                    <SocialIconSmall href={facebook_url}>
                      <FaFacebookF />
                    </SocialIconSmall>
                  )}
                  {youtube_url && (
                    <SocialIconSmall href={youtube_url}>
                      <FaYoutube />
                    </SocialIconSmall>
                  )}
                  {twitter_url && (
                    <SocialIconSmall href={twitter_url}>
                      <FaXTwitter />
                    </SocialIconSmall>
                  )}
                  {instagram_url && (
                    <SocialIconSmall href={instagram_url}>
                      <FaInstagram />
                    </SocialIconSmall>
                  )}
                  {linkedin_url && (
                    <SocialIconSmall href={linkedin_url}>
                      <FaLinkedinIn />
                    </SocialIconSmall>
                  )}
                </div>

                {/* Divider */}
                <div className="my-3 flex items-center justify-center">
                  <span className="h-[1px] w-12 bg-gradient-to-r from-transparent via-orange-400/80 to-transparent" />
                </div>
              </>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-between flex-wrap gap-3">
            <button
              type="button"
              onClick={() => onArticleClick?.(data)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-50 text-orange-600 font-medium text-xs xl:text-sm hover:bg-orange-100 transition-colors w-auto"
            >
              Read More <span className="text-sm">→</span>
            </button>

            {post_url && (
              <a
                href={post_url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 font-medium text-xs xl:text-sm hover:bg-gray-200 transition-colors w-auto"
              >
                Visit on Site <span className="text-sm">↗</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

function SocialIconSmall({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="
        w-8 h-8 flex items-center justify-center
        rounded-full border border-gray-200
        bg-white text-gray-600
        shadow-sm
        hover:bg-orange-500 hover:text-white hover:border-orange-500
        transition-all duration-300
      "
    >
      <span className="text-[14px] leading-none">{children}</span>
    </a>
  );
}
